import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";

import { promiseFetchDataAuth } from 'crk-front-lib';
// eslint-disable-next-line no-unused-vars
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { ZetaGroup } from "../zeta-widget";
// import { keepUserDataLocalStorage } from 'crk-front-lib';

const { FILL_NOT_COMPLETE, SUBSCRIPTION_DUPLICATED } = require('../configs/msg-th.json');
const appTemplate = require('../templates/member-renew-app.json');

export function RenewSubscrPage(props) {
  const history = useHistory();
  const { pkg_id } = useParams();

  const [pkgProfile, setPkgProfile] = useState({
    app:{}
  });
  const [labelMessage, setLabelMessage] = useState({
    text: '',
    classes: ''
  })

  useEffect(() => {
    promiseFetchDataAuth(`/api/v2/member/subs/${pkg_id}`)
    .then(result => {
      setPkgProfile({
        ...result, 
        app_desc: result.app.app_desc,
        app_price: result.app.app_price,
        pkg_bill_amt : parseInt(result.pkg_user_limit) * parseFloat(result.app.app_price)
      });

      if (result.app.app_status !== 'A') {
        setLabelMessage({
          text: 'โปรแกรมนี้ไม่อนุญาตให้ใช้งาน',
          classes: 'text-danger'
        })
      }
      
      if (result.app.app_type === '$') {
        alert('NOT ALLOW SUBSCRIBING TO SYSTEM APP');
        if(window.opener) {
          window.close();
        } else {
          history.push('/member/home')
        }
      }
    })
    .catch(err => {
      showAlert(err);
    })
  }, [pkg_id, history]);

  useLayoutEffect(() => {
    const txtOrgName = document.querySelector('input[name=org_name]');
    const txtUserLimit = document.querySelector('input[name=pkg_user_limit]');
    
    if (pkgProfile.app.app_type !== 'G') {
      txtOrgName.parentNode.classList.add('d-none');
      txtUserLimit.parentNode.classList.add('d-none');
    } else {
      txtOrgName.parentNode.classList.remove('d-none');
      txtUserLimit.parentNode.classList.remove('d-none');
    }

  }, [pkgProfile.app.app_type]);

  const handleSubmit = useCallback(() => {
    const form = new FormData(document.getElementById('subscr'));
    const _data = Object.fromEntries(form);
    _data.pkg_price = pkgProfile.app.app_price;
    _data.pkg_id = pkg_id;
    console.info(_data);

    if (pkgProfile.app.app_type === 'G') {
      if (
        !_data.org_name ||
        _data.org_name.trim().length === 0 ||
        !_data.pkg_user_limit ||
        _data.pkg_user_limit <= 0 ||
        !_data.pkg_price ||
        _data.pkg_price <= 0
      ) {
        showAlert(FILL_NOT_COMPLETE);
        return;
      }
    }

    promiseFetchDataAuth(`/api/v2/renew/${pkgProfile.app._id}`, 'POST', _data)
    .then(result => {
      console.info(result);
      /*
      if (result.error) {
        showAlert(result.error.message || result.error);
        return;
      }

      if (!result.code || `${result.code}`.match(/ok/i)) {
        showAlert('UNKNOWN ERROR');
      }
      */
      if (window.opener) {
        window.opener.postMessage(result, '*');
        window.close();
        return;
      }

      history.push('/member/subs');
    })
    .catch(err => {
      let _msg = err;
      if (err.match(/duplicat/i)) _msg = SUBSCRIPTION_DUPLICATED
      showAlert(_msg);
    })

  }, [pkgProfile.app.app_price, pkgProfile.app.app_type, pkgProfile.app._id, pkg_id, history]);

  const handleChange = useCallback((e) => {
    const _data = { ...pkgProfile };
    _data[e.target.name] = e.target.value;

    if (e.target.name==='pkg_user_limit') {
      _data['pkg_bill_amt'] = parseInt(e.target.value) * parseFloat(pkgProfile.app.app_price);
    }

    setPkgProfile(_data);
  }, [pkgProfile])

  return (
    <div className="row justify-content-center">
      <div className="col-xl-10 col-lg-12 col-md-9 offset-md-1">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row">
              <div className="col-lg-6 d-none d-lg-block bg-password-image"></div>
              <div className="col-lg-6">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-2">Renew Subscription</h1>
                    <p>คุณกำลังต่ออายุใช้งานโปรแกรม</p>
                  </div>
                  <form className="user" id="subscr">
                    <ZetaGroup template={appTemplate} data={pkgProfile} /*app={_this}*/ onChange={handleChange} />
                    <br />
                    <button type="button" 
                      onClick={handleSubmit}
                      className="btn btn-primary btn-user btn-block">
                      ยืนยันการต่ออายุ - Confirm
                    </button>
                  </form>
                  <hr />
                  <div className="text-center">
                    <p className={labelMessage.classes}>{labelMessage.text}</p>
                  </div>
                  {/*
                  <div className="text-center">
                    <a className="small" href="/register">Create an Account!</a>
                  </div>
                  <div className="text-center">
                    <a className="small" href="/login">Already have an account? Login!</a>
                  </div>
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}